export const ACCOUNTING_CHECKLIST_FILTERS = {
  name: 'main-settlements-checklist',
  filters: [],
};
